<!--
  Navigation Wrapper

  @since 2018-02-22
  @author kdydesign.kim
-->

<template>
  <aside>
    <div class="page-sidebar-wrapper"
         :style="`width: ${foldStyle}px`">

      <!-- Top Logo -->
      <div class="page-header-inner"
           :style="`width: ${isShowNav ? 'auto' : '160px'}`"> <!-- TAMS -->
        <div class="page-logo">
          <!-- Prism, Multi R/W 체크인 상태 시 이동방지 -->
          <nuxt-link :to="homePath" event="" @click.native.prevent="goHome($event)"
                     :key="'root'">
            <span :class="getLogoClass"></span>
<!--              <span :class="getLogoClass"-->
<!--                    :style="{width: getLogoStyle}"></span>-->
          </nuxt-link>
        </div>
      </div>

      <div class="page-sidebar"
           :style="!isShowNav ? 'left:-100%' : 'left:0'">

        <div v-global-hide="close"
             :class="[ 'page-menu-wrapper', {'no-border': !isShowNav} ]">

          <!--Main Menu (TAMS, movePage) -->
          <main-navigation ref="mainNavigation"
                           :main-menu-key="mainMenuKey"
                           @movePage="movePage"
                           @changeIsSubMenu="val => isSubMenuOpen = val"
                           @changeSubMenuKey="val => subMenuKey = val"
                           @changeMainMenuKey="val => mainMenuKey = val"></main-navigation>

          <!-- Sub Menu -->
          <!-- TAMS (movePage) -->
          <sub-navigation :sub-menu-key="subMenuKey"
                          :is-sub-menu-open="isSubMenuOpen"
                          @changeIsSubMenu="val => isSubMenuOpen = val"
                          @movePage="movePage"></sub-navigation>
        </div>

      </div><!-- END: page-sidebar -->

    </div>

    <!--Logout Confirm PopUp-->
    <confirm-dialog ref="confirmPopUp"
                    :footerBtnList="confirmBtnList"
                    @onApply="logout">
      <p>{{ $t('msg.navigation_alert_logout') }}</p>
    </confirm-dialog>
  </aside>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex'
  // component
  import MainNavigation from './MainNavigation'
  import SubNavigation from './SubNavigation'

  // TAMS
  import navigationMultirw from '~/mixins/navigationMultirw'

  // store helper
  const
    commonHelper = createNamespacedHelpers('common/common'),
    navigationHelper = createNamespacedHelpers('common/navigation'),
    authenticateHelper = createNamespacedHelpers('common/authenticate')

  export default {
    name: 'Navigation',
    mixins: [ navigationMultirw ], // TAMS
    components: {
      SubNavigation,
      MainNavigation
    },
    data () {
      return {
        foldStyle: 160,
        confirmBtnList: [
          {text: this.$tc('cmn.answer', 2), color: 'dark', type: 'no'},
          {text: this.$tc('cmn.answer', 1), color: 'primary', type: 'apply'}
        ],
        mainMenuKey: void 0,
        subMenuKey: void 0,
        isSubMenuOpen: false
      }
    },
    computed: {
      ...commonHelper.mapState([
        'uiData',
        'isShowNav'
      ]),
      ...navigationHelper.mapState([
        'menu',
        'homePath'
      ]),
      ...navigationHelper.mapGetters([
        'clientMenu'
      ]),
      getLogoStyle () {
        // TAMS
        if (this.isSubMenuOpen) {
          return '222px'
        } else {
          return '150px'
        }
      },
      getProductModel () {
        const veType = _.get(this.uiData, ['system', 've_type'], 0)
        if (veType > 0) return 've'
        return 'bluemax'
      },
      getProductSubBI () {
        return `${this.getProductModel}-logo`
      },
      getLogoClass () {
        if (this.isSubMenuOpen) {
          return `logo-default on ${this.getProductSubBI} expand-logo-enter-active`
        } else {
          return `logo-default ${this.getProductSubBI} expand-logo-enter-active`
        }
      }
    },
    methods: {
      ...authenticateHelper.mapActions([
        'logout'
      ]),
      // TAMS 미사용
      // reSelectMenu () {
      //   const changePath = this.$route.matched[0].name || this.$route.path.split('/')[1]
      //
      //   this.mainMenuKey = changePath
      //   this.subMenuKey = changePath
      //
      //   if (this.mainMenuKey === 'favorite') {
      //     this.mainMenuKey = this.subMenuKey = 'favoriteSettings'
      //   } else if (this.mainMenuKey === 'virtualSystem' && this.$route.path.indexOf('topology') === -1) {
      //     this.mainMenuKey = this.subMenuKey = this.$route.path.split('/')[3]
      //   }
      // },
      close () {
        this.isSubMenuOpen = false

        // TAMS
        const routeKey = this.$route.path.split('/')[1]
        if (this.mainMenuKey !== routeKey) {
          this.mainMenuKey = routeKey
        }
        this.$refs.mainNavigation.enterMenuKey = void 0 // 초기화
      },
      getMenuName (menu) {
        let name = ''
        switch (menu.key) {
          case 'stic':
            name = this.$t('cmn.stic')
            break
          case 'mfxSeriesMgmt':
            name = this.$t('cmn.mfxSeriesMgmt')
            break
          case 'help':
            name = this.$t('cmn.help')
            break
          case 'wips':
            name = this.$t('cmn.wips')
            break
          default:
            name = menu.name
        }
        return name
      },
      getActiveOnFlag (path) {
        return _.startsWith(this.$route.path, path)
      },
      goHome ($event) {
        // this.mainMenuKey = this.homePath.split('/')[0]
        this.movePage($event)
      }
    },
    watch: {
      // TAMS
      $route (val, old) {
        // this.reSelectMenu()

        // TAMS
        const routeKey = val.path.split('/')[1]
        if (this.mainMenuKey !== routeKey) {
          this.mainMenuKey = routeKey
        }

        // 라우팅 변경 시, sub-menu open시 닫기
        if (this.isSubMenuOpen) {
          this.isSubMenuOpen = false
        }
      },
      isShowNav (isShow) {
        if (!isShow) {
          setTimeout(() => {
            this.foldStyle = 0
          }, 500)
        } else {
          this.foldStyle = 160
        }
      }
      // TAMS 미사용 (임시주석)
      // isSubMenuOpen (value) {
      //   if (!value) {
      //     if (this.currentMenu) {
      //       this.reSelectMenu()
      //     }
      //   }
      // }
    }
  }
</script>

<style scoped>
  /*logo transition*/
  .expand-logo-enter-active {
    transition: all .5s ease-in-out;
    max-width: 222px;
  }

  /* Multi R/W 컨펌 메시지 */
  .ps-icon.ps-icon-dialog-02 {
    width: 100px !important;
  }
  .bs-q-dialog.modal-content-warning .modal-content {
    border: 2px solid #ff0000 !important;
    border-radius: 3px;
  }
</style>
